
import { api } from './api';
import { ErrorNotification } from 'app/infrastructure/notifications/user-messages';
import { errorSafe } from 'app/infrastructure/redux';
import { ApplicationState } from 'app/types-store';
import { ActionDispatching } from 'app/types-shared';
import { FailedLinks, ReceiveLinks, RequestLinks } from 'app/area/links-section/action-types';
import { mapToStore } from 'app/area/links-section/mapping/map-to-store';

export const actionCreators = {

  /**
   * Loads configurable links.
   */
  loadLinks: ():
    ActionDispatching<any, ApplicationState> => errorSafe(
      async (dispatch, getState) => {

        dispatch(new RequestLinks());

        try {
          const linksWire = await api.loadLinks();
          
          dispatch(new ReceiveLinks(mapToStore(linksWire)));

        } catch (err) {
          const errorMessage = err && (err.userMessages || err.message);
          !!errorMessage && dispatch(new ErrorNotification(errorMessage));

          dispatch(new FailedLinks());
        }
      })
};
